import { TypeParams } from "../types";

type ContextData = {
  language: string;
  action: string;
  debug: boolean;
  content?: any;
  json?: boolean;
  origin?: string;
};

const LANGUAGE = "de";
const DEBUG = true;
const URL = "https://api.velumount.ch/api.php";

export async function makeApiRequest(params: TypeParams, action: string, content: {} = {}, requiresCustomerLogin: boolean = false) {
  // Assuming 'this' context or replace 'this' with appropriate context or variables
  const contextData: ContextData = {
    language: params.language ? params.language : LANGUAGE,
    action: action,
    debug: DEBUG,
    json: true,
    origin: params.origin,
  };

  contextData.content = content;
  contextData.content = JSON.stringify(contextData.content);

  let url: string = params.backend ? params.backend : URL;
  if (params.ccid) {
    url += `?ccid=${params.ccid}`;
  }

  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
  } as any;

  let options: RequestInit = {
    method: "POST",
    headers,
    body: new URLSearchParams(contextData as any).toString(), // Convert contextData to URLSearchParams
  };

  const session_id: string | null = await localStorage.getItem("X-SESSION-ID");
  if (session_id) {
    headers["X-SESSION-ID"] = session_id;
  }
  if (requiresCustomerLogin) {
    options.credentials = "include";
  }

  try {
    const response = await fetch(url, options); // Make sure 'url' is defined
    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    // Get the custom X-SESSION-ID header from the response
    const sessionId = response.headers.get("X-SESSION-ID");
    if (sessionId) {
      localStorage.setItem("X-SESSION-ID", sessionId);
    }

    const result = await response.text(); // or `.json()` if JSON response
    return result;
  } catch (error) {
    console.error("Failed to fetch:", error);
    throw error;
  }
}
